import { render } from "./Balances.vue?vue&type=template&id=20ac41af&scoped=true"
import script from "./Balances.vue?vue&type=script&lang=js"
export * from "./Balances.vue?vue&type=script&lang=js"

import "@/assets/css/Balances.css?vue&type=style&index=0&id=20ac41af&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ac41af"]])

export default __exports__